import { Button, Stack, Typography } from "@mui/material";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { useTranslation } from "react-i18next";
import { MultiPictureUploadSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/multiPictureUploadModels";
import { Link } from "react-router-dom";
import { Download } from "@mui/icons-material";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: MultiPictureUploadSubtypeDataModel;
}

export default function MultiPictureUploadSubtypeDetails(props: Props) {
    const { t } = useTranslation();

    return <>
        <Typography variant="subtitle1">{t("incentivationPage.multiPictureUpload.uploadedImages")}</Typography>
        <Stack direction="row" flexWrap="wrap" gap={2} sx={{ mb: 2 }}>
            {
                props.subtypeData.images.map(i => <img
                    style={{ maxHeight: "400px", maxWidth: "100%", objectFit: "contain" }}
                    src={i.uploadedImageUrl} />)
            }
        </Stack>
        {
            props.subtypeData.bundleDownloadUrl &&
            <Link to={props.subtypeData.bundleDownloadUrl} target="_blank">
                <Button variant="outlined">
                    <Download />
                    {t("incentivationPage.multiPictureUpload.downloadBundle")}
                </Button>
            </Link>
        }
    </>
}
